const $accordion = $('.accordion');

if ($accordion.length > 0) {
  accordions();
}

function accordions() {
  let byTypeOpened = false;
  let byApplicationOpened = false;
  let byTradeOpened = false;
  let bySystemOpened = false;
  let byStatusOpened = false;
  let byTaskSizeOpened = false;
  let byCategoryOpened = false;
  let byPowerSourceOpened = false;
  let newsFilterOpened = false;
  let sortOpened = false;

  $('body').on('click', '.accordion .accordTop', (event) => {
    const $this = $(event.currentTarget);

    $this.parent('.accordion').toggleClass('activeAccord');

    $this.next('.accordMain').slideToggle(400, () => {
      if ($this.hasClass('byTypeFilter')) {
        byTypeOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('byApplicationFilter')) {
        byApplicationOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('byTradeFilter')) {
        byTradeOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('bySystemFilter')) {
        bySystemOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('byStatusFilter')) {
        byStatusOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('byTaskSizeFilter')) {
        byTaskSizeOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('byCategoryFilter')) {
        byCategoryOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('byPowerSourceFilter')) {
        byPowerSourceOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('newsFilter')) {
        newsFilterOpened = $this.next('.accordMain').is(':visible');
      } else if ($this.hasClass('sortFilter')) {
        sortOpened = $this.next('.accordMain').is(':visible');
      }
    });
  });

  if (byTypeOpened) {
    $('.byTypeFilter').next('.accordMain').show();
  }
  if (byApplicationOpened) {
    $('.byApplicationFilter').next('.accordMain').show();
  }
  if (byTradeOpened) {
    $('.byTradeFilter').next('.accordMain').show();
  }
  if (bySystemOpened) {
    $('.bySystemFilter').next('.accordMain').show();
  }
  if (byStatusOpened) {
    $('.byStatusFilter').next('.accordMain').show();
  }
  if (byTaskSizeOpened) {
    $('.byTaskSizeFilter').next('.accordMain').show();
  }
  if (byCategoryOpened) {
    $('.byCategoryFilter').next('.accordMain').show();
  }
  if (byPowerSourceOpened) {
    $('.byPowerSourceFilter').next('.accordMain').show();
  }
  if (newsFilterOpened) {
    $('.newsFilter').next('.accordMain').show();
  }
  if (sortOpened) {
    $('.sortFilter').next('.accordMain').show();
  }
}
